<template>
  <div class="shangquanpingjiaEvaluatePage">
    <div class="xr-mingxi">        
      <mu-appbar class="xr-head" title="评价列表">
        <mu-icon-button v-on:click="GoHistory" icon=":fa fa-angle-left" slot="left"/>
      </mu-appbar>
    </div>
    
    <v-scroll :on-refresh="onRefresh" :on-infinite="onInfinite" ref="scroll" :offset="56">
    <div class="pinglun">      
        <mu-list-item>          
          <span style="color: #999;">评论{{evaluateCount}}</span>
          <span style="float:right; width: 50%; text-align: right;">
            <mu-icon value=":fa fa-star" color="rgb(244, 67, 54)" :size="16" slot="left" v-for="eIndex in evaluateAvaStarLevel" :key="eIndex" />
            <mu-icon value=":fa fa-star" color="#ccc" :size="16" slot="left" v-for="eIndex in (5-evaluateAvaStarLevel)" :key="eIndex" />
            <span style="padding-left: 3%; color: rgb(244, 67, 54); font-size: 14px;padding-bottom: 3%;">{{evaluateAvaStarLevel}}分</span>
          </span>
        </mu-list-item>  
        <mu-divider shallowInset/> 
        <div class="id-sumary">
          <ul>
            <li v-for="evaluateItem in evaluateList" :key="evaluateItem.ShopId">              
              <div  class="timg" :style="{height: timgHeight +'px'}">
                <img :src="evaluateItem.PjUserHeadPic" alt="">
              </div> 
              <span class="nametime">{{evaluateItem.PjUserName}}</span>
              <span class="time">{{evaluateItem.PjDateName.split(' ')[0]}}</span>
              <div class="xing-div">
                <span class="fa fa-star" v-for="i in evaluateItem.StarLevel"></span>
                <span class="fa fa-star unStar" v-for="i in (5-evaluateItem.StarLevel)"></span>
              </div>
              <p class="content">{{evaluateItem.PjContent}}</p>
              <div class="pj-img-list">                
                <div class="dimg" :style="{height:dimgWidth+'px'}" v-for="imgItem in evaluateItem.Images" :key="imgItem.Id" >
                  <img :src="imgItem.ImgPath" @click="goToEvaluateImg(evaluateItem.ShopId,imgItem.Id)" />
                </div> 
              </div>
              <template v-if="evaluateItem.HfUserName">              
                <span class="nametime" style="margin-top:10px;">
                <span style="color: red;">{{evaluateItem.HfDateName.split(' ')[0]}} 商家回复：</span>{{evaluateItem.HfUserName}} </span>
                <p class="content">{{evaluateItem.HfContent}}</p>
              </template>
              <mu-divider />
            </li>
          </ul>
        </div>
      </div>  
    </v-scroll>    
    <XR-PageTip ref="XRPageTip"></XR-PageTip>
    <XR-toast ref="XRtoast"></XR-toast>
   </div>
</template>
<script>
export default {
  data() {
    return {
      proItemInfoWidth: (parseInt(document.documentElement.clientWidth)-135),      
      dimgWidth : (document.documentElement.clientWidth-16)*0.32,
      timgHeight:  (document.documentElement.clientWidth-16)*0.09,
      evaluateList:[], 
      evaluateCount:0,   
      evaluateAvaStarLevel:5.0,
      
      pageEnd : 0, // 结束页数
      num:30,
      searchInfo:{
        shopId: this.$route.query.shopId,
        pageIndex : 0, // 开始页数
        pageSize:30
      },
      scrollDone:function(){},  
    }
  },
  mounted() {
    this.getEvaluatePage(true)
  },
  methods: {
    GoHistory(){
      this.$router.goBack()
    },
    getEvaluatePage(isNewSearch){  
      if(isNewSearch){        
        this.searchInfo.pageIndex=1
      }
      else{        
        this.searchInfo.pageIndex++
      }

      const ths = this;
      this.$post("/Shop/StoreServer/GetShopsPhysicalEvaluatePage", this.searchInfo)
      .then(function(res) {
        if (res.IsSuccess) {
               
          ths.evaluateCount = res.Data.Rows
          ths.evaluateAvaStarLevel = res.Data.otherEntity
          
          if(isNewSearch){
            ths.evaluateList = res.Data.List     
          }
          else{            
            for(var i = 0; i < res.Data.List.length;i++){            
              ths.evaluateList.push(res.Data.List[i])
            }
           
          }
          ths.pageEnd = res.Data.Rows % ths.num!=0? parseInt(res.Data.Rows/ths.num)+1 : res.Data.Rows/ths.num         
          //ths.$refs.XRtoast.hide();
        }else{          
          if(isNewSearch){            
             ths.evaluateList = []
             ths.evaluateCount = 0
             ths.evaluateAvaStarLevel =5
          }     
        }
        if(ths.evaluateList.length==0){
          ths.$refs.XRPageTip.ShowEmpty('暂无数据')
        }else{
          ths.$refs.XRPageTip.initTip()
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    goToEvaluateImg(shopId, imgId){
      this.$router.push('/shangquan/pingjiaImg?shopId='+shopId + '&imgId='+imgId)
    },
    
    onRefresh(done) {
      //this.getOrderList();
      done() // call done      
    },
    onInfinite(done) {      
      this.scrollDone = done
      if(this.searchInfo.pageIndex+1 > this.pageEnd){
        this.$refs.scroll.infiniteDone()
        return
      }
      this.getEvaluatePage(false);     
    }
  },
  computed: {
    
  }
};
</script>
<style>
.shangquanpingjiaEvaluatePage .yo-scroll{
  top:56px;
}
.shangquanpingjiaEvaluatePage .xr-mingxi .mu-appbar.fixed{  
  padding:0;
  position: fixed;
  top:0;
  left: 0;
}
.shangquanpingjiaEvaluatePage .xr-mingxi .mu-appbar{
  background-color: #fff;
  color: #000;
}
.xr-mingxi .xr-head .mu-icon{
  color: #aaa;
}
.xr-mingxi .xr-head .fa-xing1{
  font-size: 24px;
  width: 28px;
  margin-right: 5px;
  padding-bottom: 5px;
}
.shangquanpingjiaEvaluatePage .productPingfen .productBanner{
  width: 100%;
  height: 230px;
  margin-bottom: 20px;
}
.shangquanpingjiaEvaluatePage .productPingfen .productBanner .wh_content{
  height: 100%;
}
.shangquanpingjiaEvaluatePage .xr-mingxi .mu-appbar-title {
    font-size: 16px;
    text-align: center;
    }
.shangquanpingjiaEvaluatePage .xr-mingxi .title .mu-icon-button {
    position: absolute;
    left: 0;
    top: 0;
    color:white;
    }
.shangquanpingjiaEvaluatePage .xr-mingxi .title .title-text {
    margin: 0;
    line-height: 48px;
    }
.shangquanpingjiaEvaluatePage .proList{
    border-bottom: 1px solid #f5f5f5;
}
.shangquanpingjiaEvaluatePage .productPingfen .proList{
  padding-left: 5%;
}
.shangquanpingjiaEvaluatePage .xr-mingxi .right{
    margin: 0 8px;
    font-size: 16px
}
.shangquanpingjiaEvaluatePage .xr-mingxi .right a{
    color: #fff;
}
.shangquanpingjiaEvaluatePage .productBanner img{
  width: 100%;
  height: 230px;
}
body .shangquanpingjiaEvaluatePage .productPingfen{
  padding-top: 0;
  margin-top: 0;
  background: #fff;
}
.shangquanpingjiaEvaluatePage .star-leval .fiveStar{
  line-height: 30px;
  height: 30px;
  align-items: center;
  display: flex;
}
.shangquanpingjiaEvaluatePage .star-leval .pjPrice{
  color: #aaa;
  padding-left: 5%;
  width:45%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.shangquanpingjiaEvaluatePage .proList .fiveStar .fa-star{
  font-size: 12px;
  width: 10px;
  height: 10px;
  color: orange;
}
.shangquanpingjiaEvaluatePage .proList .star-leval .fiveStar .fa-star{
  font-size: 12px;
  width: 12px;
  height: 10px;
  color: orange;
}
.shangquanpingjiaEvaluatePage .proList .fiveStar .empty_satr{
  font-size: 12px;
  width: 10px;
  height: 10px;
  color: #ccc;
}
.shangquanpingjiaEvaluatePage .proList .mu-item-title,.shangquanpingjiaEvaluatePage .love .proList1 .mu-item-title{
  font-size: 15px;
  font-weight: bold;
}
.shangquanpingjiaEvaluatePage .productPingfen .mu-item{
  padding: 0px 16px;
}
.shangquanpingjiaEvaluatePage .duce .mu-item-content{
  display: flex;
}
.shangquanpingjiaEvaluatePage .duce .zuo{
  width: 100%;
  padding-left: 5%;
}
.shangquanpingjiaEvaluatePage .duce .zuo .img_pro{
  height:25px;
  display:flex;
  align-items: center;
  line-height: 25px;
  font-size:12px;
  width: 33%;
  float: left;
  
}
.shangquanpingjiaEvaluatePage .duce .zuo .img_pro .pro_server{
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding-left: 5px;
  color: #999;
  width: 80%;
}
.shangquanpingjiaEvaluatePage .duce .serviceImg{
  width: 20px;
  height: 20px;
}
.shangquanpingjiaEvaluatePage .duce .you{
  width: 20%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.shangquanpingjiaEvaluatePage .duce .you .mu-raised-button{
  height: 30px;
  background: rgb(244, 67, 54);
  color: #fff;
  min-width: 100%;
}
.shangquanpingjiaEvaluatePage .duce .you .mu-raised-button .mu-raised-button-label{
  padding: 0;
}
.shangquanpingjiaEvaluatePage .love{
  background: #fff;
  margin-top: 10px;
}
.shangquanpingjiaEvaluatePage .love .proList1{
  border-bottom: 1px solid #f5f5f5;
  margin-bottom: 5px;
}
.shangquanpingjiaEvaluatePage .love .proList1 .mu-item.show-left{
  padding-left: 42px;
}
.shangquanpingjiaEvaluatePage .address .mu-item .mu-item-content{
  display: flex;
}
.shangquanpingjiaEvaluatePage .address .mu-item .dinwei{
  width: 75%;
  border-right: 1px solid #f5f5f5;
  padding-left: 16px;
}
.shangquanpingjiaEvaluatePage .address .mu-item .dinwei p{
  height: 25px;
  line-height: 25px;
}
.shangquanpingjiaEvaluatePage .address .mu-item .phone1{
  width: 20%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.shangquanpingjiaEvaluatePage .tmbtn .mu-item{
  padding: 0;
  border-top: 1px solid #f5f5f5;
  border-bottom: 1px solid #f5f5f5;
}
.shangquanpingjiaEvaluatePage  .tmbtn .mu-flat-button-label{
  color: rgb(244, 67, 54);
  font-size: 16px;
  padding: 0px;
}
.shangquanpingjiaEvaluatePage  .tmbtn .fa-angle-down,.shangquanpingjiaEvaluatePage .tmbtn .fa-angle-up{
  color: rgb(244, 67, 54);
  font-size: 18px;
}
.shangquanpingjiaEvaluatePage .zhekou {
  padding-left: 5%;
}
.shangquanpingjiaEvaluatePage .zhekou .mu-item {
  border-bottom: 1px solid #f5f5f5;
}
.shangquanpingjiaEvaluatePage .zhekou .mu-item .mu-item-content{
  display: flex;
}
.shangquanpingjiaEvaluatePage .proList .mu-item .temai{
  display: flex;
  align-items: center;
}
.shangquanpingjiaEvaluatePage .product-item ~ .product-item{
  border-top:1px solid #eee;
}
.shangquanpingjiaEvaluatePage .product-item a{  
  color:black;
}
.shangquanpingjiaEvaluatePage .product-item .pro-img{
  float: left;
  background: white;
  max-height: 90px;
}
.shangquanpingjiaEvaluatePage .product-item .product-info{
  float: left;
  padding: 1px;
  margin-left: 10px;
  word-break: break-all;
}
.shangquanpingjiaEvaluatePage .product-item  .product-info .product-name{
  overflow:hidden;
  line-height: 16px;
  height: 16px;
  font-size: 14px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.shangquanpingjiaEvaluatePage .product-item .product-info .active{
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.shangquanpingjiaEvaluatePage .product-item  .product-info .active .fontIcon{
  float: left;
  font-size: 12px;
  color:#666;
  border-radius: 2px;
  line-height: 14px;
  margin: 6px 1px;
}
.shangquanpingjiaEvaluatePage .product-item  .saleinfo{
  overflow: hidden;
  line-height: 16px;
  font-size: 12px;
}
.shangquanpingjiaEvaluatePage .product-item  .product-info .price{
  font-size: 12px;
  width: 50px;
  color: Red;
  padding: 2px 5px;
  text-align: center;
  border: 1px solid #f5c3c3;
  border-radius: 3px;
}
.shangquanpingjiaEvaluatePage .product-item  .product-info .saleinfo .price .fa{
  font-size: 14px;
  margin-right: 5px;
}
.shangquanpingjiaEvaluatePage .product-item  .product-info .saleinfo .saleCount{
  color: rgb(170, 170, 170);
    text-align: right;
    margin: 5px 0;
    overflow: auto
}
.shangquanpingjiaEvaluatePage .product-item  .product-info .saleinfo .saleCount .per_capita{
  width: 60%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  text-align: left;
  float: left;
}
.shangquanpingjiaEvaluatePage .tuijian{
  margin-top: 10px;
  padding:16px 16px;
  background: #fff;
}
.shangquanpingjiaEvaluatePage .tuijian .mu-item-right{
  right: 0px;
}
.shangquanpingjiaEvaluatePage .tuijian .mu-item {
  padding: 0; 
}
.shangquanpingjiaEvaluatePage .tuijian .caiming{
  margin-top: 10px;
}
.shangquanpingjiaEvaluatePage .tuijian .caiming .mu-item-content span{
  padding-right: 15px;
}
.shangquanpingjiaEvaluatePage .pinglun{
  background: #fff;
  margin-top: 10px;
}
.shangquanpingjiaEvaluatePage .pinglun .list1 .mu-item-title{
  font-size: 14px;
  color: rgb(244, 67, 54);
}
.shangquanpingjiaEvaluatePage .prolist2{
  background: #fff;
  margin-top: 10px;
  padding-bottom: 0;
}
.shangquanpingjiaEvaluatePage .prolist2 .mu-item-title{
  font-size: 14px;
  color: #999;
}
.shangquanpingjiaEvaluatePage .prolist2 .product-item .saleinfo {
    overflow: hidden;
    font-size: 12px;
    margin-top: 0px;
}


body .shangquanpingjiaEvaluatePage .bottomNav{
 padding: 0;
 position: fixed;
 bottom: 0;
}
.shangquanpingjiaEvaluatePage .bottomNav .maidan .mu-item-content{
  display: flex;
  align-items: center;
}
.shangquanpingjiaEvaluatePage .bottomNav .maidan .mu-item{
  box-shadow: 0px -2px 10px 0px #ccc;
  padding: 0 0 0 16px;
}
.shangquanpingjiaEvaluatePage .maidan .you{
  width: 35%;
}
.shangquanpingjiaEvaluatePage .maidan .submit{
  background: rgb(244, 67, 54);
  color: #fff;
}

.shangquanpingjiaEvaluatePage .id-sumary{
  background: white;
}
.shangquanpingjiaEvaluatePage .id-sumary ul li{
  padding:1rem 0.5rem;
  list-style: none;
}
.shangquanpingjiaEvaluatePage .id-sumary ul li .mu-divider{
  background-color: #f5f5f5; 
}
.shangquanpingjiaEvaluatePage .id-sumary ul li .timg{
  width: 9%;
  float: left;
  display:flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 50%;
  margin-right: 10px;
}
.shangquanpingjiaEvaluatePage .id-sumary ul li .timg img{
  width: 100%;
  height: 100%;
}
.shangquanpingjiaEvaluatePage .id-sumary ul li:last-child{
  box-shadow:none;
}
.shangquanpingjiaEvaluatePage .id-sumary ul li .nametime{
  display: block;
  color:#000;
  font-size: .75rem;
}
.shangquanpingjiaEvaluatePage .id-sumary ul li .time{
  float: right;
  color: #999;
  font-size: 12px;
}
.shangquanpingjiaEvaluatePage .id-sumary ul li p{
  color:#5A5655;
  font-size:14px;
  line-height: 1.4;
}
.shangquanpingjiaEvaluatePage .id-sumary ul li p.content{
  clear:both;
  margin-top: 10px;
}
.shangquanpingjiaEvaluatePage .id-sumary ul li p.content img
{
    width:50px;
    height:50px;
}
.shangquanpingjiaEvaluatePage .id-sumary ul li .pj-img-list{
  overflow: hidden;
}
.shangquanpingjiaEvaluatePage .id-sumary ul li .pj-img-list .dimg
{
  float: left;
  overflow: hidden;
  width:32%;
  margin-top: 8px;
  display:flex;
  align-items: center;
  justify-content: center;

}
.shangquanpingjiaEvaluatePage .id-sumary ul li .pj-img-list .dimg:nth-child(n+2){
  margin-left: 2%;
}
.shangquanpingjiaEvaluatePage .id-sumary ul li .pj-img-list .dimg:nth-child(4){
  margin: 0;
  margin-top: 8px;
}
.shangquanpingjiaEvaluatePage .id-sumary ul li .pj-img-list .dimg img{
    height: auto;
    width: auto;
    max-width: 100%;
    min-height: 100%;
}
.shangquanpingjiaEvaluatePage .id-sumary .id-comments-dd{
  display: none;
  font-size: .75rem;
  line-height: 2;
  color:#5A5655;
}
.shangquanpingjiaEvaluatePage .id-sumary .id-comments-dd:nth-child(2){
  display: block;
}

.shangquanpingjiaEvaluatePage .xing-div
{
    height:18px;
    overflow:hidden;
    font-size: 12px;
}
.shangquanpingjiaEvaluatePage .xing-div .fa-star{
  padding: 0 2px;
    color:red;
}
.shangquanpingjiaEvaluatePage .xing-div .fa-star.unStar{
  color:#ccc;
}

.shangquanpingjiaEvaluatePage .mu-list{
  background: #fff;
  padding: 0;
  margin-top: 10px;
}
.shangquanpingjiaEvaluatePage .mu-list .mu-item{
  padding: 0px;
}
.shangquanpingjiaEvaluatePage .mu-item.show-left{
  padding-left: 45px;
  
}
.shangquanpingjiaEvaluatePage .mu-list .proList{
  border-bottom: 1px solid #f5f5f5;
}
.shangquanpingjiaEvaluatePage .mu-list .proList2{
  border: 0;
}
.shangquanpingjiaEvaluatePage .mu-list .fa-xingxing{
  font-size: 20px;
}
.shangquanpingjiaEvaluatePage .proList .demo-flat-button .mu-flat-button-wrapper .mu-flat-button-label{
  font-size: 14px;
  padding: 0px;
}
.shangquanpingjiaEvaluatePage .proList .demo-flat-button .mu-flat-button-wrapper .fa-angle-right{
  font-size: 16px;
  color: #ccc;
}
.shangquanpingjiaEvaluatePage .proList .demo-flat-button .mu-flat-button-wrapper{
  padding-right: 16px;
}


.shangquanpingjiaEvaluatePage .product-list{
  overflow: hidden;
  margin-top: 5px;
  border-bottom:1px solid #eee;
  background: white;
}
.shangquanpingjiaEvaluatePage .product-item{
  width:100%;
  overflow: hidden;
  padding: 10px;
  height: 150px;
}
.shangquanpingjiaEvaluatePage .product-item ~ .product-item{
  border-top:1px solid #eee;
}
.shangquanpingjiaEvaluatePage .product-item a{  
  color:black;
}
.shangquanpingjiaEvaluatePage .product-item .pro-img{
  width: 95px;
  float: left;
  background: white;
  height: 95px;
}
.shangquanpingjiaEvaluatePage .product-item .product-info{
  float: left;
  padding: 1px;
  margin-left: 10px;
  word-break: break-all;
  height: 85px;
}
.shangquanpingjiaEvaluatePage .product-item  .product-info .product-name{
  overflow:hidden;
  line-height: 16px;
  height: 16px;
  font-size: 14px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.shangquanpingjiaEvaluatePage .store_name{
  font-size: 18px;width:130px;overflow: hidden;text-overflow: ellipsis;white-space:nowrap;
  float: left;
  color:#474a4f;
}
.shangquanpingjiaEvaluatePage  .distance{
    color: #666;
    text-align: right;
    float: right;
}
</style>




// WEBPACK FOOTER //
// src/pages/shangquan/sqEvaluate.vue